/* eslint-disable no-restricted-syntax */
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import tabs from '@/components/generics/tabs/tabs.vue';
import loaderMixin from '@/mixins/loader';
import cmsContentMixin from '@/mixins/cmsContent';
import { flatten, get } from 'lodash'
import { stripTags } from '@/utils/helpers';


const STORY_SWITCH_INTERVAL = 8 * 1000;
let interval = null;

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
  ],
  components: {
    tabs,
  },
  data() {
    return {
      stripTags,
      selected: {},
      selectedManually: false,
      isTransitioning: false,
      storyContentMap: {},
      activeTab: null,
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  computed: {
    ...mapState('browse', ['storiesNav', 'storyMap', 'currentStoryIndex', 'storiesUseLegacyPreload']),
    ...mapState('popup', ['currentPopup', 'currentSmallPopup']),
    showNav() {
      return this.storiesNav.length > 0 && !this.isLoading;
    },
    navigationTabs() {
      return this.storiesNav.map((item) => {
        return {
          name: `story-${item.index}`,
          title: item.navTitle || `Story #${item.index + 1}`,
        }
      })
    },
    classModifiers() {
      return {
        'preview-carousel': true,
      };
    },
    tabsClassModifiers() {
      return {
        'preview-carousel__tabs': true,
        'preview-carousel__tabs--arrows': this.showNavigationArrows
      }
    },
  },
  methods: {
    ...mapActions('browse', ['getStoriesNav', 'getStory', 'getStoriesList']),
    ...mapActions('popup', ['setCurrentPopup']),
    navigationTabChange(name) {
      this.activeTab = name;
      const index = parseInt(name.replace('story-', ''), 10);
      this.onSelect({ item: this.storiesNav.find(i => i.index === index), stop: true });
    },
    setupContent() {
      const totalCmsContent = [];
      for (const [index, data] of Object.entries(this.storyMap)) {
        totalCmsContent.push(data.desktopContent.cmsContent);
        Vue.set(this.storyContentMap, index, `${data.desktopContent.css || ''}${data.desktopContent.html || ''}`)
      }
      const accordionContentObjects = flatten(totalCmsContent.map((i) => i.accordionContentObjects));
      const podcastItemContentObjects = flatten(totalCmsContent.map((i) => i.podcastItemContentObjects));
      const contractListMarkets = flatten(totalCmsContent.map((i) => i.contractListMarkets));
      const marketTileMarkets = flatten(totalCmsContent.map((i) => i.marketTileMarkets));
      const chartWidgetObjects = flatten(totalCmsContent.map((i) => i.chartWidgetObjects));
      const docsWidgetObjects = flatten(totalCmsContent.map((i) => i.docsWidgetObjects));
      const videoWidgetObjects = flatten(totalCmsContent.map((i) => i.videoWidgetObjects));

      setTimeout(() => {
        this.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects,
              podcastItemContentObjects,
              contractListMarkets,
              marketTileMarkets,
              chartWidgetObjects,
              docsWidgetObjects,
              videoWidgetObjects
            }
          },
        });
      }, 0)
    },
    onSelect({ item, stop = false }) {
      if (typeof item === 'undefined') return Promise.resolve(1);
      const disableNavBarAutomaticProgression = get(item, 'disableNavBarAutomaticProgression', false);
      if (stop || disableNavBarAutomaticProgression) {
        this.stopNavRotation();
        this.selectedManually = true;
      }

      // this.loaderAdd();
      this.isTransitioning = true;
      // this.navbarScrollHandler();
      return this.getStory({ index: item.index })
        .then((data) => {
          // jumpy
          const timeout = 0;
          if (stop) {
            window.scrollTo(0, 0);
          }
          this.selected = item;
          setTimeout(() => {
            // this.loaderRemove();
            this.isTransitioning = false;
            // this.navbarScrollHandler();
          }, timeout);
        })
        .catch(() => this.loaderRemove());
    },
    stopNavRotation() {
      if (interval !== null) {
        clearInterval(interval);
      }
    },
    startNavRotation() {
      this.stopNavRotation();
      interval = setInterval(() => {
        const currentIndex = this.selected.index;
        const nextIndex = currentIndex === (this.storiesNav.length - 1) ? 0 : currentIndex + 1;
        this.onSelect({ item: this.storiesNav[nextIndex] });
      }, STORY_SWITCH_INTERVAL);
    },
    start() {
      this.stopNavRotation();
      this.loaderAdd(document.body);
      this.getStoriesNav()
        .then((data) => {

          if (data.length === 0) {
            this.loaderRemove(document.body);
            return Promise.resolve(1);
          }

          if (this.storiesUseLegacyPreload) {
            const promises = [];
            for (const item of data) {
              promises.push(this.getStory({ index: item.index }));
            }

             Promise.all(promises).then(() => {
               this.loaderRemove(document.body);
                this.setupContent();
                const indexToSelect = parseInt(this.$route.query.story || 1, 10);
                const item = data[indexToSelect - 1];
                this.onSelect({ item })
                  .then(() => {
                    const disableNavBarAutomaticProgression = get(item || {}, 'disableNavBarAutomaticProgression', false);
                    if (!this.currentPopup && !disableNavBarAutomaticProgression) {
                      this.startNavRotation();
                    }
                  });
             })
          } else {
            const indexes = data.map((i) => i.index);
            if (indexes.length > 0) {
              this.getStoriesList({ indexes, cache: true })
                .then(() => {
                  this.loaderRemove(document.body);
                  let item = null
                  this.setupContent();
                  if (this.$route.query.story) {
                    const indexToSelect = parseInt(this.$route.query.story, 10);
                    this.activeTab = `story-${indexToSelect - 1}`;
                    item = data[indexToSelect - 1];
                  } else {
                    this.activeTab = `story-${data[0].index}`;
                    item = data[0];
                  }

                  setTimeout(() => {
                    this.checkOverflow();
                  }, 0)
                  this.onSelect({ item })
                    .then(() => {
                      const disableNavBarAutomaticProgression = get(item || {}, 'disableNavBarAutomaticProgression', false);
                      if (!this.currentPopup && !disableNavBarAutomaticProgression) {
                        this.startNavRotation();
                      }
                    });
              }).catch((e) => {
                console.error(e);
                  this.loaderRemove(document.body);
              });
            } else {
              this.loaderRemove(document.body);
            }
          }
        })
        .catch(() => {
          this.loaderRemove(document.body);
      });
    },
    checkScrollButtons() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        const tolerance = 25;
        this.canScrollLeft = tabsList.scrollLeft > tolerance;
        this.canScrollRight = tabsList.scrollLeft < (tabsList.scrollWidth - tabsList.clientWidth - tolerance);
      }
    },
    checkOverflow() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(() => {
          this.checkScrollButtons();
        }, 250)
      }
    },
    scrollLeft() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: -150, // Scroll left by 150px
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.checkScrollButtons();
        }, 250)
      }
    },
    scrollRight() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: 150, // Scroll right by 150px
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.checkScrollButtons();
        }, 250)
      }
    },
  },
  created() {
    this.start();
  },
  watch: {
    currentPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
    currentSmallPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
  },
  beforeDestroy() {
    this.stopNavRotation();
    window.addEventListener('resize', this.checkOverflow);
  },
  mounted() {
    window.removeEventListener('resize', this.checkOverflow);
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/preview-carousel/preview-carousel.js